import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import cart from "./modules/cart";
import price from "./modules/price";
import bids from "./modules/bids";
import openWebui from "./modules/openWebui";
import agentService, { createAgentServiceStore } from "./modules/agentService";
import agentServiceUi from "./modules/agentServiceUi";
import chatWorkbench from "./modules/chatWorkbench";
import generalAgentService from "./modules/generalAgentService";
import locale from "./modules/locale";
import priceChannelSession from "./modules/priceChannelSession";

const supplyDemandAgentService = createAgentServiceStore({ sceneType: "SUPPLY_DEMAND" });

Vue.use(Vuex);

export default new Vuex.Store({
  getters: {
    token(state) {
      return state.user.userInfo.token;
    },
  },

  modules: {
    user,
    cart,
    price,
    bids,
    openWebui,
    agentService,
    supplyDemandAgentService,
    agentServiceUi,
    chatWorkbench,
    generalAgentService,
    locale,
    priceChannelSession,
  },
});
